import React, { ReactElement, useCallback, useState } from 'react'
import { debounce } from 'lodash'
import LiveTooltip from 'live/components/ui/tooltip'
import i18n from 'live/services/i18n'

type Props = {
    label: string
    value: string
    configKey: string
    onChange: (configKey: string, newValue: string) => void
    children?: unknown
    className?: string
    height?: string
}

export default function IconNameTextField(props: Props): ReactElement {
    const [value, setValue] = useState(props.value)
    const handleOnChange = (newValue: string): void => {
        setValue(newValue)
        onChange(newValue, props)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChange = useCallback(
        debounce((x, p) => p.onChange(p.configKey, x), 1000),
        []
    )

    return (
        <div className="input-config" style={{ padding: '10px 11px 3px 11px' }}>
            <div style={{ display: 'flex', backgroundColor: 'transparent' }}>
                <label style={{ marginRight: '2px' }}>{props.label}</label>
                <LiveTooltip position="top" content={i18n('ICON_NAME_DESCRIPTION')}>
                    <a className="ml-3">
                        <i className="far fa-question-circle" />
                    </a>
                </LiveTooltip>
            </div>
            <div className="input-field">
                <input
                    className={props.className}
                    type="text"
                    placeholder=""
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e.target.value)}
                    style={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        height: `${props.height ? props.height : '24px'}`
                    }}
                />
            </div>
            {props.children}
        </div>
    )
}
